var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 133,
    viewBox: "0 0 193 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.72966,
    y: 1.72966,
    width: 189.541,
    height: 129.541,
    rx: 2.27034,
    fill: "white",
    stroke: "#F3F3F3",
    strokeWidth: 3.45932
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.17 96.347H79.726V34.9532H114.17V96.347Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9326 65.645C81.9326 53.191 87.812 42.0974 96.9676 34.9482C90.2723 29.7203 81.8225 26.6 72.6392 26.6C50.8988 26.6 33.2758 44.0808 33.2758 65.645C33.2758 87.2093 50.8988 104.69 72.6392 104.69C81.8225 104.69 90.2723 101.57 96.9676 96.3419C87.812 89.1927 81.9326 78.099 81.9326 65.645Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160.625 65.645C160.625 87.2093 143.002 104.69 121.261 104.69C112.078 104.69 103.628 101.57 96.9304 96.3419C106.089 89.1927 111.968 78.099 111.968 65.645C111.968 53.191 106.089 42.0974 96.9304 34.9482C103.628 29.7203 112.078 26.6 121.261 26.6C143.002 26.6 160.625 44.0808 160.625 65.645Z",
    fill: "#F79E1B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/Mastercard.453f0b8a08287c864065c25a0cab3931.svg";
export { ForwardRef as ReactComponent };